import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

class ScrollView extends Component {
    constructor(props) {
        super(props);

        this.slideMargin = 30;
        this.thresholdTime = 200;
        this.refBody = React.createRef();
        this.refContents = React.createRef();
        this.touchStartX = 0;
        this.touchStartY = 0;
        this.touchBefore = 0;
        this.touchStartTime = null;
        this.lock = true;
        this.state = {
            pos: 0,
        }
    }
    componentDidMount() {
    }
    scroll = (pos) => {
        this.refBody.current.scrollBy({
            left:0, 
            top: pos,
            behavior: "smooth"
        });
    }
    scrollTo = (pos) => {
        this.refBody.current.scrollTo({
            left:0, 
            top: pos,
            behavior: "smooth"
        });
    }
    getScrollPos = () => {
        return this.refBody.current.scrollTop;
    }
    getBodyHeight = () => {
        return this.refBody.current.getBoundingClientRect().height;
    }
    render() {
        return (
            <Body name="scroll-view" ref={this.refBody} Width={this.props.width} Height={this.props.height}>
                <Contents ref={this.refContents}>
                    {this.props.contents}
                </Contents>
            </Body>
        );
    }
}

export { ScrollView };

ScrollView.propTypes = {
    width: PropTypes.string.isRequired,
    height: PropTypes.string.isRequired,
    contents: PropTypes.node.isRequired,
    onClick: PropTypes.func,
};

const Body = styled.div`
    width: ${props => (props.Width)};
    height: ${props => (props.Height)};
    display: flex;
    flex-direction: column;
    // border-bottom: 1px solid #dddddd;
    overflow: auto;
    position: relative;
    -webkit-overflow-scrolling: touch;
`;
const Contents = styled.div`
    width: 100%;
    transition-duration: 0.1s;
`;
